<template>
  <!-- 套餐 -->
  <div class="pckWrap" v-loading="loading">
    <!-- [公司设立] / [公司服务的转移 – 公司秘书相关的服务] -->
    <el-form ref="dataForm" :model="dataForm" :rules="dataRule" label-width="126px">
      <el-form-item prop="goodsList" ref="goodsList">
        <div class="comboListWrap">
          <!-- 套餐 -->
          <div
            v-for="(item, index) in packageList"
            :key="item.id"
            class="mt26 mr20 comboWrap"
            :class="{ comboActive: activePkgIndex == index }"
            @click="selectPackageHandle(index, item)"
          >
            <p class="title">
              {{ getLanguage == "zh" ? item.packageNameCn : item.packageName }}
            </p>
            <div class="details">
              <p class="price">{{ priceCurrencyFormat(item.price, item.currency) }}</p>
              <p class="markingPrice">({{ serviceListPriceSum(item.serviceList, item.currency) }})</p>
              <div class="applicability">
                <!-- 适用人群 -->
                <p class="pt20">{{ $t("creation.crowd") }}</p>
                <p class="lh16 black88 fs12 pt8">
                  {{ getLanguage == "zh" ? item.applicablePersonCn : item.applicablePerson }}
                </p>
              </div>
              <div class="listWrap">
                <!-- 套餐包含： -->
                <p class="name black45 fwb">
                  {{ $t("creation.comboInclude") }}
                </p>
                <ul>
                  <li v-for="child in item.serviceList" :key="'child' + child.id" class="black45 pt4">
                    <span class="fwb green fs12 el-icon-check"></span>
                    {{ getLanguage == "zh" ? child.descriptionCn : child.description }}
                    <span v-if="$isNumberLike(child.serviceFee)">({{ priceCurrencyFormat(child.serviceFee, child.currency) }})</span>
                    <info-popover
                      placement="top"
                      :content="getLanguage == 'zh' ? child.serviceScopeCn : child.serviceScope"
                      iconClass="fs13 grey"
                      v-if="child.serviceScopeCn && child.serviceScope"
                    />
                  </li>
                </ul>
                <!-- 第三方费用 -->
                <p class="pt4">
                  <span class="fwb green fs12 el-icon-check"></span>
                  {{ $t("creation.priceInclude") }}
                </p>
                <ul>
                  <li v-for="subset in mergeSameAttrList(item.serviceList, 'thirdPartyFeeDescription', 'thirdPartyFee')" :key="`subset-${subset.id}`" class="black88 pt4">
                    -
                    {{ getLanguage == "zh" ? subset.thirdPartyFeeDescriptionCn : subset.thirdPartyFeeDescription }}
                    <span v-if="$isNumberLike(subset.thirdPartyFee)">({{ priceCurrencyFormat(subset.thirdPartyFee, subset.currency) }})</span>
                  </li>
                </ul>
                <!-- 其他费用 -->
                <p class="pt4">
                  <span class="fwb green fs12 el-icon-check"></span>
                  {{ $t("creation.otherExpenses") }}
                </p>
                <ul>
                  <li v-for="other in mergeSameAttrList(item.serviceList, 'otherFeeDescription', 'otherFee')" :key="`other-${other.id}`" class="black88 pt4">
                    -
                    {{ getLanguage == "zh" ? other.otherFeeDescriptionCn : other.otherFeeDescription }}
                    <span v-if="$isNumberLike(other.otherFee)">({{ priceCurrencyFormat(other.otherFee, other.currency) }})</span>
                  </li>
                </ul>
              </div>
            </div>
            <p class="el-icon-success pitch"></p>
          </div>
          <!-- 自定义套餐 -->
          <div @click="selectPackageHandle(-1)">
            <diy-package ref="diyPackageRef" :country="country" :businessType="businessType" :activePkgIndex="activePkgIndex" @update="updateDiySelectedServiceList" />
          </div>
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { getAction } from "@/api/common";
import { validateLocation } from "@/utils/common";
import DiyPackage from "./DiyPackage.vue";
import formatMixin from "@/mixins/formatMixin";
import priceCountMixin from "@/mixins/priceCountMixin";
import { mapGetters } from "vuex";
export default {
  mixins: [formatMixin, priceCountMixin],
  components: {
    DiyPackage,
  },
  props: {
    country: {
      type: String,
      default: "",
    },
    businessType: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      dataForm: {
        goodsListType: null,
        goodsList: [],
      },
      dataRule: {
        goodsList: [
          {
            type: "array",
            required: true,
            message: this.$t("common.placeholder.select"),
            trigger: "submit",
          },
        ],
      },
      packageList: [],
      serviceList: [],
      diyGoodsList: [],
      activePkgIndex: null,
      loading: false,
    };
  },
  computed: {
    ...mapGetters("language", ["getLanguage"]),
  },
  methods: {
    // 初始化
    init() {
      // 表单进行重置
      this.$refs["dataForm"]?.resetFields();
      this.getPackageList();
      // 初始化自定义套餐
      this.$refs.diyPackageRef?.init();
    },
    // 获取套餐列表
    getPackageList() {
      this.loading = true;
      getAction("/package/getList", {
        country: this.country,
        businessType: this.businessType,
      })
        .then(res => {
          const resData = res.data || [];
          this.packageList = resData;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    // 选择套餐或自定义套餐
    selectPackageHandle(index, item) {
      this.activePkgIndex = index;
      if (index != -1) {
        this.dataForm = {
          goodsListType: 1,
          goodsList: [
            {
              productId: item.id,
              productType: "package",
            },
          ],
        };
      } else {
        // 从子级组件触发更新选中的服务列表的方法，来更新dataForm
        this.$refs.diyPackageRef.emitSelectedServiceList();
      }
    },
    // 更新自定义套餐选中的服务列表
    updateDiySelectedServiceList(selectedList) {
      const goodsList = selectedList.map(item => ({ productType: "service", productId: item.id }));
      this.diyGoodsList = goodsList;
      this.dataForm = { goodsListType: 2, goodsList: [...goodsList] };
    },
    // 提交表单(由父级触发)
    dataFormSubmit() {
      return new Promise((resolve, reject) => {
        this.$refs["dataForm"].validate((valid, object) => {
          if (valid) {
            // 当自定义套餐为空时，提示
            if (this.dataForm.goodsListType == 2 && this.dataForm.goodsList.length == 0) {
              this.$message.warning(this.$t("common.warning.customModule"));
              reject();
            } else {
              resolve({
                ...this.dataForm,
              });
            }
          } else {
            validateLocation(object, this);
            reject();
          }
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.pckWrap {
  min-height: 300px;
}

::v-deep {
  .comboWrap {
    padding: 30px 15px;
    width: 286px;
    /* min-height: 430px; */
    border: 1px solid #dbe3ee;
    border-radius: 6px;
    line-height: 1;
    cursor: pointer;
    font-size: 12px;
    /* text-align: justify; */

    .title {
      font-size: 14px;
      font-weight: 600;
      text-align: center;
      line-height: 18px;
    }

    .price {
      font-size: 22px;
      padding-top: 16px;
      font-weight: 600;
      text-align: center;
      color: #0060ff;
    }

    .markingPrice {
      padding-top: 6px;
      text-decoration: line-through;
      color: #bbc6d8;
      text-align: center;
      font-size: 14px;
      font-weight: bold;
    }

    .applicability {
      padding-top: 8px;
    }

    .listWrap {
      text-align: left;
      padding: 12px 16px;
      background: #f4f8fe;
      line-height: 18px;
      margin-top: 16px;
      border-radius: 6px;
    }

    .include {
      padding-top: 14px;
      text-align: left;
      text-align: justify;
    }

    .include p {
      line-height: 20px;
      padding-bottom: 2px;
    }

    .include li {
      width: 100%;
      display: inline-block;
      line-height: 18px;
    }

    .pitch {
      display: none;
      position: absolute;
      bottom: 4px;
      right: 4px;
      color: #0060ff;
      font-size: 26px;
      z-index: 100;
    }
  }

  .comboListWrap {
    display: flex;
    flex-wrap: wrap;

    .comboActive {
      border: 1px solid #0060ff;
      position: relative;
    }

    .comboActive {
      .price {
        color: #ff8a00;
      }

      .pitch {
        display: block;
      }
    }
  }
}
</style>
